var _circle, _g, _path, _mask, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 133,
    viewBox: "0 0 140 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69.7574,
    cy: 66,
    r: 50,
    fill: "#6725D2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4398_207202)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    transform: "translate(37.7574 34)",
    fill: "#6725D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7574 77.2003L50.5574 66.0003L46.8241 69.7336L61.7574 84.6669L93.7574 52.6669L90.0241 48.9336L61.7574 77.2003Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.257 100C121.257 91.4396 114.318 84.5 105.757 84.5C97.197 84.5 90.2574 91.4396 90.2574 100C90.2574 108.56 97.197 115.5 105.757 115.5C114.318 115.5 121.257 108.56 121.257 100Z",
    fill: "#6725D2",
    stroke: "#F3EAFF",
    strokeWidth: 3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_4398_207202",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.759 108.816C101.223 108.816 97.5343 105.127 97.5343 100.591H99.4882C99.4882 104.047 102.3 106.862 105.759 106.862C109.219 106.862 112.03 104.05 112.03 100.591H113.984C113.984 105.127 110.295 108.816 105.759 108.816Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.759 108.816C101.223 108.816 97.5343 105.127 97.5343 100.591H99.4882C99.4882 104.047 102.3 106.862 105.759 106.862C109.219 106.862 112.03 104.05 112.03 100.591H113.984C113.984 105.127 110.295 108.816 105.759 108.816Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5343 100.591V97.5908H94.5343V100.591H97.5343ZM99.4882 100.591H102.488V97.5908H99.4882V100.591ZM112.03 100.591V97.5908H109.03V100.591H112.03ZM113.984 100.591H116.984V97.5908H113.984V100.591ZM105.759 105.816C102.88 105.816 100.534 103.47 100.534 100.591H94.5343C94.5343 106.784 99.5661 111.816 105.759 111.816V105.816ZM97.5343 103.591H99.4882V97.5908H97.5343V103.591ZM96.4882 100.591C96.4882 105.703 100.642 109.862 105.759 109.862V103.862C103.958 103.862 102.488 102.391 102.488 100.591H96.4882ZM105.759 109.862C110.876 109.862 115.03 105.707 115.03 100.591H109.03C109.03 102.393 107.562 103.862 105.759 103.862V109.862ZM112.03 103.591H113.984V97.5908H112.03V103.591ZM110.984 100.591C110.984 103.47 108.639 105.816 105.759 105.816V111.816C111.952 111.816 116.984 106.784 116.984 100.591H110.984Z",
    fill: "#F3EAFF",
    mask: "url(#path-4-inside-1_4398_207202)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.13 0.00012778L120.451 10.0426L130.499 15.3683L120.451 20.694L115.126 30.7412L109.8 20.6941L99.7574 15.373L109.805 10.0473L115.13 0.00012778Z",
    fill: "#6725D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.243 42.7414L133.531 39.7149L130.501 34.0002L127.472 39.7149L121.757 42.7441L127.472 45.7733L130.499 51.4854L133.528 45.7707L139.243 42.7414Z",
    fill: "#6725D2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7888 125.515L9.53172 123.259L7.27411 119L5.01649 123.259L0.757447 125.517L5.01648 127.774L7.27209 132.031L9.52971 127.772L13.7888 125.515Z",
    fill: "#6725D2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4398_207202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(37.7574 34)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.935214fd80b85ec7c1fb126233ca4cfd.svg";
export { ForwardRef as ReactComponent };